import { useEffect, useState } from "react";
import { ExternalLink, Loader2, Puzzle, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import api, { fmtDate } from "@/lib/api";

export const VIA_LABEL = { helper: "Helper", helper_auto: "Auto Siaran", helper_bg: "Mod Latar" };

function Summary({ data }) {
  return (
    <div className="mb-6 grid grid-cols-2 gap-4 sm:max-w-md">
      <div className="panel p-5" data-testid="helper-history-total-groups"><p className="eyebrow">Group berjaya</p><p className="mt-3 font-mono text-3xl">{data.total_groups}</p></div>
      <div className="panel p-5" data-testid="helper-history-total-posts"><p className="eyebrow">Jumlah post</p><p className="mt-3 font-mono text-3xl">{data.total_posts}</p></div>
    </div>
  );
}

function Modes({ modes }) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {Object.entries(modes).filter(([, n]) => n > 0).map(([k, n]) => (
        <span key={k} className="rounded-full bg-primary/15 px-2 py-0.5 text-[10px] font-semibold text-primary">{VIA_LABEL[k]} · {n}</span>
      ))}
    </div>
  );
}

export default function HelperHistory() {
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/helper/history").then((r) => setData(r.data)).catch(() => setData({ total_groups: 0, total_posts: 0, groups: [] })); }, []);
  if (!data) return <Loader2 className="h-5 w-5 animate-spin text-primary" />;
  const shown = data.groups.filter((g) => g.group_name.toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="helper-history">
      <Summary data={data} />
      <div className="relative mb-4 sm:max-w-md">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari group..." className="h-10 bg-card pl-9" data-testid="helper-history-search" />
      </div>
      <div className="panel overflow-x-auto">
        <Table data-testid="helper-history-table">
          <TableHeader>
            <TableRow className="border-border hover:bg-transparent">
              <TableHead>Group</TableHead>
              <TableHead className="text-right">Jumlah berjaya</TableHead>
              <TableHead>Cara</TableHead>
              <TableHead>Terakhir dipost</TableHead>
              <TableHead />
            </TableRow>
          </TableHeader>
          <TableBody>
            {shown.length === 0 && (
              <TableRow><TableCell colSpan={5} className="py-10 text-center text-sm text-muted-foreground" data-testid="helper-history-empty">
                <Puzzle className="mx-auto mb-2 h-5 w-5 text-primary" />Belum ada group yang berjaya dipost oleh Helper.
              </TableCell></TableRow>
            )}
            {shown.map((g) => (
              <TableRow key={g.group_id || g.group_url} className="border-border" data-testid={`helper-history-row-${g.group_id}`}>
                <TableCell className="max-w-xs"><p className="truncate font-medium">{g.group_name}</p>{g.last_text && <p className="line-clamp-1 text-xs text-muted-foreground">{g.last_text}</p>}</TableCell>
                <TableCell className="text-right font-mono text-lg" data-testid={`helper-history-count-${g.group_id}`}>{g.count}</TableCell>
                <TableCell><Modes modes={g.modes} /></TableCell>
                <TableCell className="whitespace-nowrap font-mono text-xs text-muted-foreground" data-testid={`helper-history-last-${g.group_id}`}>{g.last_at ? fmtDate(g.last_at) : "-"}</TableCell>
                <TableCell><a href={g.group_url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 text-xs text-primary hover:underline"><ExternalLink className="h-3.5 w-3.5" /> Buka</a></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
